// @ts-nocheck
const VAULT_BASE_URL = '/vault';
const BULK_UPLOAD_URL = `${VAULT_BASE_URL}/bulkupload`;
const AUTH_URL = `${VAULT_BASE_URL}/auth`;
const O_AUTH_URL = `${VAULT_BASE_URL}/oauth`;
const CUSTOM_ENTITY_URL = `${VAULT_BASE_URL}/custom-entity`;
const TEMPLATE_VERSION_URL = `${VAULT_BASE_URL}/template-version`;
const MODEL_ENTITY_URL = `${VAULT_BASE_URL}/model-entity`;
const BULK_TRANSITION_URL = `${VAULT_BASE_URL}/bulktransition`;
const CUSTOM_REPORTS_URL = `${VAULT_BASE_URL}/customreports`;
const DYNAMIC_CHARTS_URL = `${VAULT_BASE_URL}/dynamiccharts`;
const LLM_URL = `${VAULT_BASE_URL}/llm`;
const AUTOMATION_URL = `${VAULT_BASE_URL}/automation`;
const RESOURCE_TEAM = `${VAULT_BASE_URL}/team`;
const RESOURCE_PLANING = `${RESOURCE_TEAM}/effort-management`;
const BULK_UPDATE_URL = `${VAULT_BASE_URL}/bulkupdate`;
const EMAIL_TEMPLATES_URL = `${VAULT_BASE_URL}/email-templates/`;
const C_LOCK_URL = `${VAULT_BASE_URL}/lock`;
const BULK_DOCUMENT_URL = `${VAULT_BASE_URL}/bulk-document`;
const DASHBOARD_CONFIG = `${AUTH_URL}/dashboard-config`;
const REG_MAP = `${LLM_URL}/regulatory-guideline`;
const ENTITY_SERVICE_URL = `${VAULT_BASE_URL}/entity-service`;
const JOURNAL_URL = `${VAULT_BASE_URL}/journal`;
const DYNAMIC_TOOLBAR_URL = `${VAULT_BASE_URL}/dyn-toolbar`;
const CHANGE_REQUEST_IMPACT = `${VAULT_BASE_URL}/impact`;
const ENTITIES_URL = `${VAULT_BASE_URL}/entities`;

const API_ENDPOINTS = {
  HOSTS_NEEDS_TOKEN: [window.CONFIG.HOSTS_NEEDS_TOKEN],
  MODULE_BASE_URL: {
    AUTH: window.CONFIG.VAULT_BASE_URL,
  },
  AUTH: {
    LOGIN_USER: `${AUTH_URL}/login/`,
    USER_DETAIL: `${AUTH_URL}/user-detail`,
    LOGOUT_USER: `${AUTH_URL}/logout/`,
    LOGOUT_USER_COMMON_AUTH: `/access-management/logout/`,
    GET_ALL_USER: `${AUTH_URL}/getAlluser`,
    CREATE_USER: `${AUTH_URL}/register/`,
    GET_ALL_ROLES: `${VAULT_BASE_URL}/roles`,
    USER_PERMISSION: `${AUTH_URL}/getUserPermission`,
    UPDATE_USER: `${VAULT_BASE_URL}/profile/update/`,
    ROLE_LINKAGES_UPDATE: `${VAULT_BASE_URL}/roleLinkagesUpdate`,
    SUSPEND_USER: `${AUTH_URL}/suspend`,
    REFRESH_TOKEN: `${AUTH_URL}/token/refresh/`,
    REFRESH_TOKEN_COMMON_AUTH: `/access-management/refresh/`,
    FORGET_PASSWORD: `${AUTH_URL}/request_reset_email/`,
    RESET_PASSWORD: `${AUTH_URL}/password_reset_complete/`,
    USER_SETTING: `${AUTH_URL}/user-settings`,
    IS_LOGGED_IN_USER_ADMIN_OF_GROUP: `${AUTH_URL}/isAdmin`,
    VALIDATE_ACCOUNT: `${AUTH_URL}/get_details_for_sso`,
    SHARE_ACCESS: `${AUTH_URL}/shareAccess`,
    FRONTEND_CONFIG: `${AUTH_URL}/plugins`,
    IMPERSONATION_START: `${AUTH_URL}/impersonation/start`,
    IMPERSONATION_STOP: `${AUTH_URL}/impersonation/stop`,
    IMPERSONATION_STATUS: `${AUTH_URL}/impersonation/status`,
  },
  NOTIFICATIONS: {
    GET_NOTIFICATION: `${VAULT_BASE_URL}/notification/getAll`,
    GET_NOTIFICATION_COUNT: `${VAULT_BASE_URL}/notification/getCount`,
    CLEAR_NOTIFICATION: `${VAULT_BASE_URL}/notification/clearAll`,
    READ_UNREAD: `${VAULT_BASE_URL}/notification/Marksingleread`,
    MARK_ALL_READ: `${VAULT_BASE_URL}/notification/MarkAsRead`,
    GET_ALL_NOTIFICATIONS: `${VAULT_BASE_URL}/notification/manageAnnouncements`,
    SSE: '/sse/stream',
  },
  CE: {
    CREATE_ENTITY: CUSTOM_ENTITY_URL,
    GET_SINGLE_ENTITY: CUSTOM_ENTITY_URL,
    CREATE_SECTION: `${CUSTOM_ENTITY_URL}/section`,
    GET_SECTIONS_DETAILS: `${CUSTOM_ENTITY_URL}/section`,
    REMOVE_SECTION: `${CUSTOM_ENTITY_URL}/section`,
    CREATE_ATTRIBUTES: `${CUSTOM_ENTITY_URL}/attribute`,
    GET_ATTRIBUTES: `${VAULT_BASE_URL}/get-attribute`,
    REMOVE_ATTRIBUTE: `${CUSTOM_ENTITY_URL}/attribute`,
    ATTACH_WORKFLOW: `${CUSTOM_ENTITY_URL}/workflow`,
    DELETE_TEMPLATE: CUSTOM_ENTITY_URL,
    REORDER_TEMPLATE: `${VAULT_BASE_URL}/orderRearrange`,
    GET_MODEL_DETAILS_OF_WORKFLOW_CHANGES: `${CUSTOM_ENTITY_URL}/updateworkflow`,
    TRANSITION_ALL_MODELS: `${CUSTOM_ENTITY_URL}/updateworkflow`,
    GET_WORKFLOW_ROLES: `${VAULT_BASE_URL}/workflow/getAllRoles`,
    CHECK_TEMPLATE: `${CUSTOM_ENTITY_URL}/checkTemplate`,
    IMPORT_TEMPLATE: `${CUSTOM_ENTITY_URL}/importTemplate`,
    DOWNLOAD_SAMPLE_TEMPLATE: `${CUSTOM_ENTITY_URL}/sampleTemplateExcel`,
    EXPORT_TEMPLATE: `${CUSTOM_ENTITY_URL}/exportTemplate`,
    IMPORT_ATTRIBUTE: `${CUSTOM_ENTITY_URL}/importAttribute`,
    DOWNLOAD_SAMPLE_ATTRIBUTE: `${CUSTOM_ENTITY_URL}/SampleAttributesExcel`,
    EXPORT_ATTRIBUTE: `${CUSTOM_ENTITY_URL}/exportAttributes`,
    MODEL_MANAGEMENT: `${CUSTOM_ENTITY_URL}/model-management`,
    CYCLIC_PROCESS: `${CUSTOM_ENTITY_URL}/model-management/cycle-config`,
    ARTIFACT_PROCESS: `${VAULT_BASE_URL}/artifactprocess`,
    ARTIFACT_PROCESS_STATUS: `${VAULT_BASE_URL}/artifactprocessstatus`,
    HEALTH_DEFINITIONS: `${CUSTOM_ENTITY_URL}/health-definitions`,
    FORMULA_PLACEHOLDERS: `${CUSTOM_ENTITY_URL}/placeholders`,
    SETTINGS: `${CUSTOM_ENTITY_URL}/settings`,
    GLOBAL_ATTRIBUTES_REPORT: `${VAULT_BASE_URL}/global-attribute-report`,
    LOCAL_ATTRIBUTES_REPORT: `${VAULT_BASE_URL}/local-attribute-report`,
    GET_ATTRIBUTE_REPORTS: `${VAULT_BASE_URL}/report-list`,
    DOWNLOAD_REPORT: `${VAULT_BASE_URL}/Download-report`,
    GET_REPORT_TYPES: `${VAULT_BASE_URL}/get_filter_type`,
    GET_SUMMARY_SECTIONS_ATTRIBUTES_ORDER: `${CUSTOM_ENTITY_URL}/summary-sections`,
    ORDER_SUMMARY_SECTIONS_ATTRIBUTES_ORDER: `${CUSTOM_ENTITY_URL}/summary-attribute-order`,
    AVAILABLE_ATTRIBUTES: `${CUSTOM_ENTITY_URL}/get_available_attributes`,
    IS_CYCLE_PROCESS_ENABLED: `${CUSTOM_ENTITY_URL}/model-management/is-cycle-enabled`,
    OVERRIDE_ATTRIBUTE_CONSTRAINT: `${CUSTOM_ENTITY_URL}/override-attribute-constraints`,
    DYNAMIC_KEY_GENERATION: `${VAULT_BASE_URL}/key-generation/patterns`,
    DYNAMIC_KEY_RECALCULATION: `${VAULT_BASE_URL}/key-generation/recalculate`,
    ENTITY_SERVICE: `${ENTITY_SERVICE_URL}/relationDefinition`,
    ENTITY_SERVICE_HISTORY: `${ENTITY_SERVICE_URL}/relationDefinition/history`,
    CREATE_TEMPLATE_VERSION: `${TEMPLATE_VERSION_URL}/create`,
    GET_TEMPLATE_VERSIONS: `${TEMPLATE_VERSION_URL}/list`,
    SET_DEFAULT_TEMPLATE_VERSION: `${TEMPLATE_VERSION_URL}/set-default`,
    PUBLISH_TEMPLATE_VERSION: `${TEMPLATE_VERSION_URL}/publish`,
    MIGRATE_ENTITIES_TO_TEMPLATE_VERSION: `${TEMPLATE_VERSION_URL}/migrate`,
    COMPARE_TEMPLATE_VERSIONS: `${TEMPLATE_VERSION_URL}/compare`,
    GET_TEMPLATE_LIST: `${CUSTOM_ENTITY_URL}/get-all-templates`,
    GET_VERSIONS_COMMON_ATTRIBUTES: `${TEMPLATE_VERSION_URL}/get-common-attributes`,
    CHANGE_REQUEST_ATTR_BLACKLIST: `${CUSTOM_ENTITY_URL}/change-management/attribute-blacklist`,
  },
  MI: {
    GET_QUERY_LIST: `${VAULT_BASE_URL}/query/list`,
    SEARCH_QUERY: `${VAULT_BASE_URL}/query/search`,
    CREATE_QUERY: `${VAULT_BASE_URL}/query/create`,
    GET_QUERY_BY_ID: `${VAULT_BASE_URL}/query`,
    UPDATE_QUERY: `${VAULT_BASE_URL}/query`,
    UPLOAD_QUERY_ATTACHMENT: `${VAULT_BASE_URL}/query/attachment`,
    QUERY_BASE: `${VAULT_BASE_URL}/query`,
    QUERY_CATEGORIES: `${VAULT_BASE_URL}/query/categories`,
    BULK_QUERY_TEMPLATE: `${VAULT_BASE_URL}/query/bulk-upload/template`,
    BULK_QUERY_UPLOAD: `${VAULT_BASE_URL}/query/bulk-upload`,
    QUERY_STATS: `${VAULT_BASE_URL}/query/stats`,
    ENTITY_TYPE_GROUPS: `${VAULT_BASE_URL}/query/entity-type-groups`,
    QUERY_ACTIONS: `${VAULT_BASE_URL}/query`,
    TRANSITION_QUERY: `${VAULT_BASE_URL}/query`,
    DOWNLOAD_ATTACHMENT: `${VAULT_BASE_URL}/query/query_attachments/`,
    READ_ALL_MODEL_ENTITY: `${MODEL_ENTITY_URL}/readAll`,
    LITE_READ_ALL_MODEL_ENTITY: `${MODEL_ENTITY_URL}/readAllLite`,
    CREATE_MODEL_ENTITY_FIRST_STEP: `${MODEL_ENTITY_URL}/createModel`,
    CREATE_MODEL_ENTITY_SECOND_STEP: `${MODEL_ENTITY_URL}/updateModel/attribute`, // remove
    CREATE_MODEL_ENTITY_THIRD_STEP: `${MODEL_ENTITY_URL}/createModel/addModelAssociaton`,
    CREATE_MODEL_ENTITY_FORTH_STEP: `${MODEL_ENTITY_URL}/createModel/addModelTeam`,
    ATTRIBUTE_DETAILS: `${MODEL_ENTITY_URL}/get_attributes_data`,
    GET_HTML_ATTRIBUTE_VALUE: `${MODEL_ENTITY_URL}/render-html-attribute`,
    TEAM_DETAILS: `${MODEL_ENTITY_URL}/modelTeam`,
    ASSOCIATION_DETAILS: `${MODEL_ENTITY_URL}/read/modelAssociation`,
    ADD_SINGLE_TEAM_MEMBER: `${MODEL_ENTITY_URL}/createModel/addSingleTeam`,
    DELETE_ENTITY: `${MODEL_ENTITY_URL}/removeModel`,
    MODEL_APPROVE: `${VAULT_BASE_URL}/workflow/NextStage`,
    FORCE_MODEL_APPROVE: `${VAULT_BASE_URL}/workflow/forceNextStage`,
    SAVE_FILTER: `${VAULT_BASE_URL}/savesearch`,
    REMOVE_TEAM_MEMBER: `${MODEL_ENTITY_URL}/removeModel/teamMember`,
    REMOVE_MODEL_ASSOCIATION: `${MODEL_ENTITY_URL}/removeModel/association`,
    GET_SINGLE_ENTITY: `${MODEL_ENTITY_URL}/readSingle`,
    HISTORY: `${MODEL_ENTITY_URL}/modelHistory`,
    GET_LOG_ACTIONS: `${MODEL_ENTITY_URL}/getLogactions`,
    GET_LOG_ACTIONS_ATTRIBUTES: `${MODEL_ENTITY_URL}/getLogattributes`,
    GET_NOTES: `${MODEL_ENTITY_URL}/modelNotes`,
    GET_REPLIES: `${VAULT_BASE_URL}/replies`,
    GET_TRANSITION_STATES: `${VAULT_BASE_URL}/transitionstates`,
    GET_LIFECYCLE_NOTES: `${VAULT_BASE_URL}/lifecycle-note`,
    NOTES: `${VAULT_BASE_URL}/notes`,
    ADD_NOTES: `${MODEL_ENTITY_URL}/updateModel/addNote`,
    DELETE_FILTER: `${VAULT_BASE_URL}/savesearch`,
    EDIT_FILTER: `${VAULT_BASE_URL}/search`,
    GET_ALERTS: `${VAULT_BASE_URL}/alerts`,
    UPDATE_MODEL: `${MODEL_ENTITY_URL}/updateModel/attribute`,
    EXCEL_IMPORT: `${VAULT_BASE_URL}/bulkupload/template`,
    EXCEL_UPLOAD: `${VAULT_BASE_URL}/bulkupload/upload/`,
    CREATE_VERSION: `${VAULT_BASE_URL}/createversion`,
    GET_VERSIONS: `${VAULT_BASE_URL}/getallversions`,
    ROLLBACK_VERSION: `${VAULT_BASE_URL}/rollbackversion`,
    VERSIONS_COMPARISON: `${VAULT_BASE_URL}/compare-version`,
    GET_REPORTS: `${VAULT_BASE_URL}/reports`,
    GET_CATEGORY: `${VAULT_BASE_URL}/category/`,
    LINK_REPORT: `${VAULT_BASE_URL}/report-type/link/`,
    REPORT_LIST: `${VAULT_BASE_URL}/report-list`,
    REPORT_TYPES: `${VAULT_BASE_URL}/report-types`,
    REPORT_PERMISSIONS: `${VAULT_BASE_URL}/report-types/permissions`,
    LINKED_REPORT_TYPES: `${VAULT_BASE_URL}/linked-reporttypes`,
    EXECUTE_SQL_QUERY: `${VAULT_BASE_URL}/sql/execute/`,
    EXECUTE_AND_SAVE_QUERY: `/api/sql/execute-and-save`,
    AI_SQL_QUERY_ASSISTANT: `${LLM_URL}/text-to-sql`,
    AI_SQL_SCHEMA_SYNC: `${LLM_URL}/sync-schema`,
    GENERATE_CHART: `${VAULT_BASE_URL}/sql/generate-graph/`,
    CHART_LIST: `${VAULT_BASE_URL}/sql/graph-list/`,
    VIEW_CHART: `${VAULT_BASE_URL}/sql/visualise-graph/`,
    GET_DATABASE_SCHEMA: `${VAULT_BASE_URL}/database/schema`,
    GET_SAMPLE_QUERY: `${VAULT_BASE_URL}/database/sample-queries`,
    REFRESH_DATABASE_SCHEMA: `${VAULT_BASE_URL}/database/refresh/`,
    EXPORT_REPORT_AS_EXCEL: `${VAULT_BASE_URL}/generate-report`,
    DOWNLOAD_GENERATED_REPORTS: `${VAULT_BASE_URL}/generated-reports/download`,
    DOWNLOAD_GENERATED_REPORT_LOG: `${VAULT_BASE_URL}/generated-reports/logs`,
    CATEGORY_LIST_REPORT: `${VAULT_BASE_URL}/generated-reports`,
    UPDATE_CANVAS: `${VAULT_BASE_URL}/canvas-template/update/`,
    GET_CANVAS: `${VAULT_BASE_URL}/canvas-template`,
    GET_SYNC_STATUS: `${VAULT_BASE_URL}/database/refresh-status/`,
    PREVIEW_PDF_REPORT: `${VAULT_BASE_URL}/generate-report`,
    POWER_BI_REPORT: `${VAULT_BASE_URL}/PowerBI/Reports`,
    VIEW_REPORTS: `${VAULT_BASE_URL}/view-generated-report`,
    SCHEDULE_REPORT: `${VAULT_BASE_URL}/schedule`,
    GET_CURRENT_STATES: `${MODEL_ENTITY_URL}/status`,
    GET_MODEL_LINAGE: `${VAULT_BASE_URL}/graphplotforsingleentity/getnodes`,
    WORKFLOW_CHECKLIST: `${VAULT_BASE_URL}/workflow/checklist`,
    ALERT_EVENT: `${MODEL_ENTITY_URL}/alert_events`,
    MODEL_AVAILABLE: `${MODEL_ENTITY_URL}/available`,
    SAVE_DRAFT: `${VAULT_BASE_URL}/draft`,
    GET_FIELDS_DATA_TYPES: `${MODEL_ENTITY_URL}/getDataType`,
    GET_STATE_DETAILS: `${MODEL_ENTITY_URL}/StatesDetails`,
    GET_SHOW_IN_SUMMARY: `${MODEL_ENTITY_URL}/showInSummary`,
    GET_TEMPLATE_ASSOCIATIONS: `${MODEL_ENTITY_URL}/getLifecycleDetails`,
    GET_PARENT_ASSOCIATION: `${MODEL_ENTITY_URL}/read/parentAssociation`,
    ISSUE_DATA: `${MODEL_ENTITY_URL}/read/validationArtifacts`,
    SEARCH_MODELS: `${VAULT_BASE_URL}/search-notes-entity`,
    GET_GLOBAL_ATTRIBUTE_VALUE: `${VAULT_BASE_URL}/globalattribute-value`,
    GET_LOCAL_ATTRIBUTE_VALUE: `${VAULT_BASE_URL}/attribute-value`,
    GET_MODEL_PREVIOUS_STATE: `${MODEL_ENTITY_URL}/getModelPreviousState`,
    PRECHECK_TRANSITION: `${MODEL_ENTITY_URL}/precheck-transition`,
    RECLAIM_STATE: `${MODEL_ENTITY_URL}/modelReclaim`,
    DOWNLOAD_INVENTORY_VIEW_REPORT: `${MODEL_ENTITY_URL}/inventory-view-download-report`,
    DOWNLOAD_LOGS: `${MODEL_ENTITY_URL}/modelHistoryDownload`,
    GET_USER_ROLE_PERMISSIONS: `${MODEL_ENTITY_URL}/getUserPermission`,
    GET_MAPPED_VALUES: `${MODEL_ENTITY_URL}/getMappedValues`,
    DOWNLOAD_REPORTS_DOCUMENT: `${VAULT_BASE_URL}/activityReport`,
    GET_ALL_ASSOCIATIONS: `${MODEL_ENTITY_URL}/get_all_associations`,
    ARCHIVE_ENTITY: `${MODEL_ENTITY_URL}/archive`,
    DOWNLOAD_REPORT_ENTITIES: `${MODEL_ENTITY_URL}/report-download`,
    ENTITY_STATUSES: `${MODEL_ENTITY_URL}/dropdownAttributes`,
    DOWNLOAD_CONNECTIVITY_REPORT: `${MODEL_ENTITY_URL}/report-architecture`,
    GET_ATTRIBUTES_COMMENTS: `${MODEL_ENTITY_URL}/attribute-comments`,
    DOWNSTREAM_ENTITIES: `${MODEL_ENTITY_URL}/get-downstream-entities`,
    ADD_SUB_ROLES: `${MODEL_ENTITY_URL}/addSubRoles`,
    GET_APPROVAL_DETAILS: `${VAULT_BASE_URL}/workflow/getApprovalDetails`,
    UPLOAD_FILE_FOR_ATTRIBUTE: `${VAULT_BASE_URL}/upload-document-for-attribute`,
    GET_ATTRIBUTE_SOURCE_MAPPING: `${MODEL_ENTITY_URL}/attribute-source-mapping`,
    UPDATE_USER_DETAILS: `${MODEL_ENTITY_URL}/updateTeamMember`,
    GET_LOG_STATE: `${MODEL_ENTITY_URL}/getLogstates`,
    FREEZE_STATE: `${MODEL_ENTITY_URL}/freeze_entity`,
    CLONE_ENTITY: `${MODEL_ENTITY_URL}/clone_artifact`,
    SECTION_PERMISSIONS: `${MODEL_ENTITY_URL}/section-permissions`,
    UPDATE_ARTIFACT_CYCLE: `${MODEL_ENTITY_URL}/update-artifact-cycle`,
    CYCLE_SIDEBAR_DATA: `${MODEL_ENTITY_URL}/cycles`,
    GET_CALCULATION_RELATED_ATTRIBUTES: `${CUSTOM_ENTITY_URL}/calculation-related-attributes`,
    CALCULATE_ATTRIBUTE_VALUE: `${MODEL_ENTITY_URL}/calculate-attribute-value`,
    OVERRIDE_ATTRIBUTE_VALUE: `${MODEL_ENTITY_URL}/override-attribute-value`,
    GET_OVERRIDE_ATTRIBUTE_VALUE: `${MODEL_ENTITY_URL}/override-attribute-value`,
    GET_DOWNSTREAM_UPSTREAM_ENTITIES: `${VAULT_BASE_URL}/getUpstreamDownstreamEntities`,
    MAKER_CHECKER: `${MODEL_ENTITY_URL}/workflowMakerChecker`,
    CONSTRAINT_SOURCES: `${MODEL_ENTITY_URL}/get-constraint-sources`,
    GET_CONSTRAINTS: `${MODEL_ENTITY_URL}/get-constraint`,
    GET_ASSOCIATION_ATTRIBUTES_DATA: `${MODEL_ENTITY_URL}/getAssociationAttributesData`,
    GET_USERS_ATTRIBUTES_DATA: `${MODEL_ENTITY_URL}/getUsersAttributesData`,
    GROUP_DETAILS: `${MODEL_ENTITY_URL}/group-details`,
    GET_IMPACTED_ATTRIBUTES_DATA: `${MODEL_ENTITY_URL}/getImpactedAttributeData`,
    GET_INVENTORY_VIEW: `${MODEL_ENTITY_URL}/get-inventory-view`,
    RAISE_REQUEST_FOR_ENTITY: `${MODEL_ENTITY_URL}/RaiseRequestForEntity`,
    LINKED_ENTITIES: `${MODEL_ENTITY_URL}/linked-entites`,
    GET_LINKED_TEMPLATE_ENTITIES: `${MODEL_ENTITY_URL}/get-linked-template-entities`,
    ADVANCED_VARIABLES: `${VAULT_BASE_URL}/advanced-variables`,
    ADVANCED_VARIABLES_CRUD: `${VAULT_BASE_URL}/advanced-variables/manage`,
    CALCULATE_ADV_TABLE_ROW: `${VAULT_BASE_URL}/advanced-table/calculate-row/`,
    GET_ADV_TABLE_COLUMN_CONSTRAINTS: `${VAULT_BASE_URL}/advanced-table/get-column-constraints/`,
    GET_ADV_TABLE_CONSTRAINT_SOURCES: `${VAULT_BASE_URL}/get-adv-constraint-sources/`,
    PRECHECK_ADVANCED_TABLE: `${VAULT_BASE_URL}/precheck-advanced-table/`,
    APPROVE_SEGMENT_TRANSITION: `${MODEL_ENTITY_URL}/approve-segment-transition`,
    GET_CHANGE_REQUEST_FIELD_OPTIONS: `${CHANGE_REQUEST_IMPACT}/constants/field-change-map`,
    GET_IMPACT_ANALYSIS: `${CHANGE_REQUEST_IMPACT}/get-impact`,
    ATTRIBUTE_LIST_KEYS: `${ENTITIES_URL}/attributes/dropdown`,
    ATTRIBUTE_LIST_VALUES: `${ENTITIES_URL}/attributes/dropdown/values`,
    META_DATA: `${MODEL_ENTITY_URL}/model-meta-data`,
    BEDROCK_OPTION_LIST: `${VAULT_BASE_URL}/bedrock/resources`,
  },
  DOC: {
    MODEL_DOCUMENTS: `${VAULT_BASE_URL}/document`,
    UPLOAD_DOCUMENTS: `${VAULT_BASE_URL}/upload-document`,
    CREATE_DOCUMENT: `${VAULT_BASE_URL}/create-document`,
    EDIT_DOCUMENTS: `${VAULT_BASE_URL}/edit_document`,
    UPLOAD_TEMPLATE: `${VAULT_BASE_URL}/documenttemplateupload`,
    DOCUMENT_TEMPLATE: `${VAULT_BASE_URL}/documenttemplate`,
    DOCUMENT_ONEDRIVE_URL: `${VAULT_BASE_URL}/documentonedriveview`,
    DOCUMENT_TREE: `${VAULT_BASE_URL}/doc_tree`,
    DOWNLOAD_DOCUMENT: `${VAULT_BASE_URL}/export-document`,
    REPLACE_DOCUMENT: `${VAULT_BASE_URL}/update-document`,
    GET_TAGS: `${VAULT_BASE_URL}/documentTags`,
    DOWNLOAD_TEMPLATE_DOCUMENT: `${VAULT_BASE_URL}/documenttemplatedownload`,
    UPLOAD_CHUNK: `${VAULT_BASE_URL}/upload-chunk`,
    START_UPLOAD: `${VAULT_BASE_URL}/start-upload`,
    COMPLETE_UPLOAD: `${VAULT_BASE_URL}/complete_upload`,
    UPDATE_DOCUMENT: `${VAULT_BASE_URL}/update-document`,
    ASSOCIATED_DOCUMENT: `${VAULT_BASE_URL}/associated-document`,
    ATTRIBUTE_DOCUMENT: `${VAULT_BASE_URL}/attibute-document`,
    UPLOAD_STATUS: `${VAULT_BASE_URL}/upload-status`,
    DOCUMENT_LINKED_ENTITIES: `${VAULT_BASE_URL}/document-linked-entities`,
    UPDATE_LINKED_ENTITIES: `${VAULT_BASE_URL}/update-document-link`,
  },
  SCHEMA: {
    START_UPLOAD: `${VAULT_BASE_URL}/constants/excel/start-upload`,
    UPLOAD_CHUNK: `${VAULT_BASE_URL}/constants/excel/upload-chunk`,
    COMPLETE_UPLOAD: `${VAULT_BASE_URL}/constants/excel/complete-upload`,
  },
  RR: {
    RULES: `${VAULT_BASE_URL}/rules`,
    ADVANCED_REPORT_QUERIES: `${VAULT_BASE_URL}/advanced-report-queries`,
  },
  WF: {
    CREATE_WORKFLOW: `${VAULT_BASE_URL}/workflow/create`,
    CLONE_WORKFLOW: `${VAULT_BASE_URL}/workflow/clone`,
    GET_WORKFLOW_LIST: `${VAULT_BASE_URL}/workflow/viewAll`,
    COMPILE_FLOW: `${VAULT_BASE_URL}/workflow/recompile`,
    UPDATE_FLOW: `${VAULT_BASE_URL}/workflow/update`,
    DRAFT_WORKFLOW: `${VAULT_BASE_URL}/workflow/saveAsDraft`,
    GET_SINGLE_WORKFLOW: `${VAULT_BASE_URL}/workflow/view`,
    GET_ALL_STATES: `${VAULT_BASE_URL}/workflow/Allstate`,
    NEXT_POSSIBLE_STATE: `${VAULT_BASE_URL}/workflow/getNextState`,
    DELETE_WORKFLOW: `${VAULT_BASE_URL}/workflow/delete`,
    CHECK_WORKFLOW_STATE_DELETABLE: `${VAULT_BASE_URL}/workflow/checkstate`,
    UPDATE_STATE: `${VAULT_BASE_URL}/workflow/updateState`,
    GET_WORKFLOW_GROUPS: `${VAULT_BASE_URL}/workflow/get-all-workflow-groups`,
  },
  GA: {
    GLOBAL_ATTRIBUTES: `${VAULT_BASE_URL}/globalattributes`,
    GLOBAL_ATTRIBUTE_ORDER: `${VAULT_BASE_URL}/globalattribute-order`,
  },
  DB: {
    GET_FILTER: `${VAULT_BASE_URL}/savesearch`,
    GET_FILTERED_DATA: `${VAULT_BASE_URL}/search`,
    GET_NODES: `${VAULT_BASE_URL}/graphplot/getnodes/`,
    PLOT_GRAPH: `${VAULT_BASE_URL}/graphplot/plotgraph/`,
    FULL_SEARCH: `${VAULT_BASE_URL}/fullsearch`,
    PIPELINE: `${VAULT_BASE_URL}/pipeline`,
    DASHBOARD_REPORTS: `${VAULT_BASE_URL}/dashreports`,
    UPDATE_ALERT: `${VAULT_BASE_URL}/update_alert_field`,
    ALL_EVENTS: `${VAULT_BASE_URL}/allevents`,
    EVENTS_COUNT: `${VAULT_BASE_URL}/get_events_count`,
    GET_ALERTS: `${VAULT_BASE_URL}/alert`,
    GET_KIBAN_DASHBOARD: `${VAULT_BASE_URL}/kibanadashboard`,
    GET_PENDING_TASKS: `${MODEL_ENTITY_URL}/MyTask`,
    GET_OPEN_TASKS: `${VAULT_BASE_URL}/auth/openTasks`,
    GET_TASK_QUEUE: `${VAULT_BASE_URL}/worker-queue`,
    GET_TASK_RESULT: `${VAULT_BASE_URL}/get-single-task`,
    TOGGLE_RULE: `${MODEL_ENTITY_URL}/toggleDelegation`,
    SAVE_RULE: `${MODEL_ENTITY_URL}/saveRules`,
    CLAIM_DELEGATION: `${MODEL_ENTITY_URL}/claimDelegation`,
    DELEGATE_TASK: `${MODEL_ENTITY_URL}/taskDelegate`,
    GET_DELEGATED_TASK: `${MODEL_ENTITY_URL}/getDelegatedTasks`,
    GET_DELEGATED_RULE: `${MODEL_ENTITY_URL}/saveRules`,
    GET_CHECKER_TASK: `${MODEL_ENTITY_URL}/CheckerTask`,
    GET_TEAM_EFFORT_LIST: `${RESOURCE_PLANING}/members`,
    GET_MEMBER_TASKS: `${RESOURCE_PLANING}/detail`,
    GET_OPEN_TASK_COUNT: `${RESOURCE_PLANING}/opentask-count`,
    GET_TEMPLATES: `${RESOURCE_TEAM}/status-management`,
    GET_TEMPLATES_TASK_DETAILS: `${RESOURCE_TEAM}/status-management/detail`,
    EVENTS: `${VAULT_BASE_URL}/events`,
    GET_ALL_SAVED_SEARCH: `${VAULT_BASE_URL}/allsavedsearch`,
    GET_LANDSCAPE_SCHEMA: `${VAULT_BASE_URL}/model-landscape-schema`,
    GET_LANDSCAPE_DATA: `${VAULT_BASE_URL}/model-landscape`, // remove its support
    GET_LANDSCAPE_DATA2: `${VAULT_BASE_URL}/user-personalized-landscape`,
    USER_SELECTED_ENTITIES: `${VAULT_BASE_URL}/user-selected-entities`,
    LANDSCAPE_SINGLE_ENTITY: `${VAULT_BASE_URL}/landscape-single-entity`,
    GET_LANDSCAPE_VIEWS: `${VAULT_BASE_URL}/landscape-views`,
    GET_TASK_QUEUE_FILTER: `${VAULT_BASE_URL}/worker-queue-filter`,
  },
  DI: {
    GET_INVENTORY: `${VAULT_BASE_URL}/docinv`,
    DOC_SEARCH: `${VAULT_BASE_URL}/documentsearch`,
    DOC_SFTP_SYNC: `${VAULT_BASE_URL}/document_sftp_sync`,
    GET_DOC_MARKDOWN: `${VAULT_BASE_URL}/file-content`,
    GET_VERSION_DETAILS: `${VAULT_BASE_URL}/doc-version`,
    ROLL_BACK_VERSION: `${VAULT_BASE_URL}/rollback-document`,
  },
  BU: {
    GET_FILES: `${BULK_UPLOAD_URL}/files/`,
    CREATE_MODEL: `${BULK_UPLOAD_URL}/create-model/`,
    DELETE_FILE: `${BULK_UPLOAD_URL}/files/delete`,
    DOWNLOAD_FILE: `${BULK_UPLOAD_URL}/downloadfile`,
  },
  TA: {
    THEME: `${VAULT_BASE_URL}/theme-customization`,
    USER_THEME_SETTINGS: `${VAULT_BASE_URL}/userThemeSettings`,
  },
  UM: {
    CREATE_GROUP: `${AUTH_URL}/creategroup`,
    DELETE_GRPUP: `${AUTH_URL}/deletegroup`,
    GET_GROUPS: `${AUTH_URL}/readgroup`,
    UPDATE_GROUP: `${AUTH_URL}/updategroup`,
    GET_GROUP_TASKS: `${AUTH_URL}/getGroupTask`,
    ASSIGN_TASK: `${AUTH_URL}/assignTask`,
    GET_ROLES: `${VAULT_BASE_URL}/roles`,
    GET_ISSUE_TYPE: `${CUSTOM_ENTITY_URL}/issue-type`,
    CREATE_ISSUE_TYPE: `${CUSTOM_ENTITY_URL}/issue-type`,
    UPDATE_ISSUE_TYPE: `${CUSTOM_ENTITY_URL}/issue-type`,
    DELETE_ISSUE_TYPE: `${CUSTOM_ENTITY_URL}/issue-type`,
    GET_SUMMARY_SECTIONS: `${MODEL_ENTITY_URL}/modelSummarySection`,
    CREATE_SUMMARY_SECTIONS: `${MODEL_ENTITY_URL}/modelSummarySection`,
    UPDATE_SUMMARY_SECTIONS: `${MODEL_ENTITY_URL}/modelSummarySection`,
    DELETE_SUMMARY_SECTIONS: `${MODEL_ENTITY_URL}/modelSummarySection`,
  },
  AM: {
    REGISTER_APP: `${O_AUTH_URL}/register`,
    GET_ALL_APPS: `${O_AUTH_URL}/all-applications`,
  },
  BA: {
    GET_ALL_MODELS: `${BULK_TRANSITION_URL}/allModel`,
    GET_STATES: `${BULK_TRANSITION_URL}/getState`,
    BULK_TRANSITION: `${BULK_TRANSITION_URL}/transition`,
    GET_BULK_TRANSITION_FILTER: `${BULK_TRANSITION_URL}/filter`,
  },
  DC: {
    GET_ALL_REPORT_DETAILS: CUSTOM_REPORTS_URL,
    SAVE_CHART: CUSTOM_REPORTS_URL,
    DELETE_CHART: CUSTOM_REPORTS_URL,
    GET_COLUMNS_NAMES: `${DYNAMIC_CHARTS_URL}/columns`,
    GET_COLUMNS_METADATA: DYNAMIC_CHARTS_URL,
    CHECK_CHART_EXIST: `${VAULT_BASE_URL}/checkdynamicchartexists`,
  },
  NOTES: {
    COMMENTS: `${MODEL_ENTITY_URL}/model_comment`,
  },
  NUI: {
    GET_ALL_MODELS: `${VAULT_BASE_URL}/nimbus/getallmodels`,
    GET_ALL_PROJECTS: `${VAULT_BASE_URL}/nimbus/model-entity/getnimbusprojectlist`,
    INTEGRATE_ENTITY: `${VAULT_BASE_URL}/nimbus/model-entity/enablemodelintegration`,
    GET_ALL_PIPELINES: `${VAULT_BASE_URL}/nimbus/getpipelinelist`,
    RUN_PIPELINE: `${VAULT_BASE_URL}/nimbus/runpipeline`,
    PIPELINE_STATUS: `${VAULT_BASE_URL}/nimbus/getpipelinestatus`,
    GET_REDIRECTION_URL: `${VAULT_BASE_URL}/nimbus/redirection`,
    UNLINK_ENTITY: `${VAULT_BASE_URL}/nimbus/unlink_model`,
  },
  LLM: {
    DOC_CHAT: `${LLM_URL}/chat`,
    ENTITY_CHAT: `${LLM_URL}/modelchat`,
    DOC_AVAILABLE: `${LLM_URL}/check`,
    DOC_UPLOAD: `${LLM_URL}/document`,
    ENTITY_UPLOAD: `${LLM_URL}/modeltrain`,
    DOWNLOAD_WEAKNESS_ASSESSMENT: `${LLM_URL}/v2/doc-assess`,
    GENERATE_TEXT_TO_WORKFLOW: `${LLM_URL}/text-to-workflow`,
    SUGGEST_FIELDS: `${LLM_URL}/suggest-fields`,
    MODEL_SESSIONS: `${LLM_URL}/model-sessions`,
    DOC_SESSIONS: `${LLM_URL}/document-chat-sessions`,
    LLM_BASED_FILTER: `${LLM_URL}/text-to-filter`,
    SYNC_ATTRIBUTES_TO_DOCSEARCH: `${LLM_URL}/sync-attributes-to-docsearch`,
  },
  SP: {
    GET_SHAREPOINT_FILES: `${VAULT_BASE_URL}/sharepoint/files`,
    SYNC_SHAREPOINT_FILES: `${VAULT_BASE_URL}/sharepoint/sync_document`,
    GET_PROCESS_NAMES: `${VAULT_BASE_URL}/sharepoint/get-processes`,
    GET_PROCESS_FILES: `${VAULT_BASE_URL}/sharepoint/get-process-files`,
    SUBMIT_FILES_FOR_MIGRATION: `${VAULT_BASE_URL}/sharepoint/pipeline`,
    SEARCH_INVENTORY: `${VAULT_BASE_URL}/sharepoint/search-files`,
    STOP_SEARCH: `${VAULT_BASE_URL}/sharepoint/stop_search`,
  },
  PGN: {
    FETCH_PLUGINS: `${AUTH_URL}/plugins`,
  },
  AUT: {
    CREATE_AUTOMATION: AUTOMATION_URL,
    UPDATE_AUTOMATION: AUTOMATION_URL,
    GET_AUTOMATION: AUTOMATION_URL,
    DELETE_AUTOMATION: AUTOMATION_URL,
    RETRIGGER_AUTOMATION: `${VAULT_BASE_URL}/retrigger-send-mail`,
  },
  HELP_SUPPORT: {
    DOCUMENTS: `${VAULT_BASE_URL}/admin-help`,
    RESTRUCTURE: `${VAULT_BASE_URL}/admin-help/restructure`,
  },
  BULK_UPDATE: {
    GET_EXCEL_TEMPLATE: `${BULK_UPDATE_URL}/template/`,
    UPLOAD_TEMPLATE: `${BULK_UPDATE_URL}/upload/`,
    TRIGGER_UPDATE: `${BULK_UPDATE_URL}/update-attributes/`,
    FILE_LIST: `${BULK_UPDATE_URL}/files`,
    DELETE_FILE: `${BULK_UPDATE_URL}/files/delete`,
    BULK_UPDATE_ATTRIBUTES: `${VAULT_BASE_URL}/bulk-update/updateAttributes`,
    CREATE_BULK_ENTITIES: `${VAULT_BASE_URL}/bulk-create/entities`,
  },
  EMAIL_TEMPLATE: {
    GET_ALL_EMAIL_TEMPLATES: `${EMAIL_TEMPLATES_URL}`,
    CREATE_EMAIL_TEMPLATE: `${EMAIL_TEMPLATES_URL}`,
    UPDATE_EMAIL_TEMPLATE: `${VAULT_BASE_URL}/email-templates-detail/`,
    GET_EMAIL_TEMPLATE_TAGS: `${VAULT_BASE_URL}/email-templates-tags/`,
  },
  EMAIL_SETTINGS: {
    GET: `${AUTH_URL}/email-settings/`,
    PATCH: `${AUTH_URL}/email-settings/`,
  },
  C_LOCK: {
    GET_LOCK: C_LOCK_URL,
    UPSERT_LOCK: C_LOCK_URL,
  },
  BULK_DOC_UPLOAD: {
    FILE_LIST: `${BULK_DOCUMENT_URL}/files`,
    DOWNLOAD_EXCEL: `${BULK_DOCUMENT_URL}/download-template`,
    UPLOAD_EXCEL: `${BULK_DOCUMENT_URL}/upload`,
    TRIGGER_UPDATE: `${BULK_DOCUMENT_URL}/process-docs`,
  },
  DASHBOARD_CONFIG: {
    SAVE_UPDATE_DASHBOARD: `${DASHBOARD_CONFIG}/save-update-dashboard`,
    FETCH_SAVE_UPDATE_DASHBOARD: `${DASHBOARD_CONFIG}/save-update-dashboard`,
    VIEW_DASHBOARD: `${DASHBOARD_CONFIG}/view-dashboard`,
    DELETE_DASHBOARD: `${DASHBOARD_CONFIG}/save-update-dashboard`,
  },
  REG_MAP: {
    UPLOAD_REG_FILE: `${REG_MAP}/file`,
    GET_SINGLE_REG_FILE: `${REG_MAP}/file`,
    GET_ALL_REG_FILE: `${REG_MAP}/file`,
    DELETE_REG_FILE: `${REG_MAP}/file`,
    RUN_REG_FILE: `${REG_MAP}/assessment`,
    GET_SINGLE_RUN_REG_FILE: `${REG_MAP}/assessment`,
    GET_ALL_RUN_REG_FILE: `${REG_MAP}/assessment`,
    DOWNLOAD_REG_REPORT: `${REG_MAP}/assessment/report`,
  },
  CNF: {
    ATTR: {
      GET_ALL_ATTRIBUTES: `${CUSTOM_ENTITY_URL}/attribute`,
      HTML_ATTRIBUTE_UPLOAD_TEMPLATE: `${CUSTOM_ENTITY_URL}/html-attribute/upload-template`,
      HTML_ATTRIBUTE_DOWNLOAD: `${CUSTOM_ENTITY_URL}/downloadAttribute`,
      SYSTEM_GENERATED_ATTRIBUTES: `${MODEL_ENTITY_URL}/system-generated-attributes`,
    },
    CA: {
      GET_ALL_CONSTANT_ATTRIBUTES: `${VAULT_BASE_URL}/constants`,
      CREATE_CONSTANT_ATTRIBUTE: `${VAULT_BASE_URL}/constants`,
      UPDATE_CONSTANT_ATTRIBUTE: `${VAULT_BASE_URL}/constants`,
      DELETE_CONSTANT_ATTRIBUTE: `${VAULT_BASE_URL}/constants`,
      GET_SINGLE_CONSTANT_ATTRIBUTE: `${VAULT_BASE_URL}/constants`,
      GET_SCHEMA: `${VAULT_BASE_URL}/constants/schema`,
      EDIT_EXCEL_SCHEMA: `${VAULT_BASE_URL}/constants/excel/edit`,
      PROGRESS_STATUS: `${VAULT_BASE_URL}/constants/excel/progress-status`,
      GET_VERSIONS: `${VAULT_BASE_URL}/constants/excel/versions`,
      ROLLBACK_VERSION: `${VAULT_BASE_URL}/constants/excel/rollback`,
    },
    TEMP: {
      ADD_ATTRIBUTES: `${CUSTOM_ENTITY_URL}/addAttribute`,
      REMOVE_ATTRIBUTES: `${CUSTOM_ENTITY_URL}/removeAttribute`,
      REORDER_ATTRIBUTES: `${CUSTOM_ENTITY_URL}/reorderAttribute`,
      REORDER_SECTIONS: `${CUSTOM_ENTITY_URL}/reorderSection`,
      COLUMN_REORDER: `${CUSTOM_ENTITY_URL}/column-reorder`,
      GET_COLUMN_REORDER: `${CUSTOM_ENTITY_URL}/column-reorder`,
    },
    DYT: {
      GET_ALL_TOOLBARS_LIST: `${DYNAMIC_TOOLBAR_URL}`,
      GET_SIDEBAR_OPTIONS: `${DYNAMIC_TOOLBAR_URL}/options`,
      GET_TEMPLATE_BY_ID: `${DYNAMIC_TOOLBAR_URL}/template`,
      CREATE_TOOLBAR: `${DYNAMIC_TOOLBAR_URL}`,
      UPDATE_TOOLBAR: `${DYNAMIC_TOOLBAR_URL}`,
    },
  },
  LOGS: {
    CNFLOG: {
      GET_ALL_LOGS: `${JOURNAL_URL}/configuration`,
      GET_ALL_CONFIGURATION_DATA_LIST: `${JOURNAL_URL}/filter-data`,
      GET_ALL_CONFIGURATION_DROPDOWN_LIST: `${JOURNAL_URL}/filter-metadata`,
      DOWNLOAD_LOGS_REPORT: `${JOURNAL_URL}/download-logs-report`,
    },
  },
  SEGMENTS: {
    GET_SEGMENTS: `${MODEL_ENTITY_URL}/segments`,
    CREATE_SEGMENT: `${MODEL_ENTITY_URL}/segments`,
    UPDATE_SEGMENT: `${MODEL_ENTITY_URL}/segments`,
    DELETE_SEGMENT: `${MODEL_ENTITY_URL}/segments`,
    DUPLICATE_SEGMENT: `${MODEL_ENTITY_URL}/segment-duplicate-check`,
    CHECK_INPROGRESS: `${MODEL_ENTITY_URL}/segment-progress`,
  },
  SECTIONS: {
    GET_SECTIONS: `${MODEL_ENTITY_URL}/copy-sections`,
    CREATE_SECTIONS: `${MODEL_ENTITY_URL}/copy-sections`,
    UPDATE_SECTIONS: `${MODEL_ENTITY_URL}/copy-sections`,
    DELETE_SECTIONS: `${MODEL_ENTITY_URL}/copy-sections`,
  },
};
export default API_ENDPOINTS;
